module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "ack"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The author thanks the archivists and librarians who made his research possible, especially Christina Moeller of the Akademie der Künste in Berlin and Dr. Deborah Rose-Lefmann of Northwestern University. Robert Sloan of the Indiana University Press has been an ideal editor, and Harriet Lightman remains the author’s indispensable collaborator.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a27ef4d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 78
// module chunks = 0